import { render, staticRenderFns } from "./HorizontalCardListItem.vue?vue&type=template&id=26389442&scoped=true&"
import script from "./HorizontalCardListItem.vue?vue&type=script&lang=ts&"
export * from "./HorizontalCardListItem.vue?vue&type=script&lang=ts&"
import style0 from "./HorizontalCardListItem.vue?vue&type=style&index=0&id=26389442&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26389442",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
